import { Record } from "immutable";

import createFromJS from "../../createFromJS";

export const SyncUpdatePropertyRecord = Record({
  documentId: null,
  fieldId: null,
  lastSyncValue: null,
  externalValue: null,
  localValue: null,
  action: null
});

createFromJS.registerCallback(
  "SyncUpdatePropertyRecord",
  createFromJS.createPrimitiveCallback(SyncUpdatePropertyRecord)
);
